"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryOptionsDialog = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _contexts = require("../../contexts");
var _addressFormContext = require("../../contexts/addressFormContext");
var _models = require("../../models");
var _Loading = require("../Loading");
var _DeliveryOptionsDialogContent = require("./DeliveryOptionsDialogContent");
var _styles = require("./styles");
var _useDeliveryOptionsDialog = require("./useDeliveryOptionsDialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const AddressForm = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/address-form')))).DeliveryAddressForm
}));
const ConfirmDeleteAddressDialog = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../addresses/ConfirmDeleteAddressDialog'))));
const FindPickupPoints = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../FindPickupPoints/FindPickupPoints'))));
const SelectPickupPointDialog = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../SelectPickupPointDialog/SelectPickupPointDialog'))));
const DeliveryOptionsDialog = props => {
  const {
    isFlatSelection,
    isDeliveryOptionsLoaded,
    onDeliveryItemActivation,
    selectedItem,
    toggleDeliveryOptionsDialog
  } = props;
  const options = (0, _useDeliveryOptionsDialog.useDeliveryOptionsDialog)(props);
  const {
    deliveryOptionsTitle,
    findPickupPointsProps,
    isFindPickupPointsOpen,
    isMapEnabled,
    isMapListMergeEnabled,
    togglePickupPointsDialog
  } = options;
  const {
    addressFormProps,
    addressFormTitle,
    confirmDeleteAddressDialogProps,
    isAddressFormOpen,
    isConfirmDeleteAddressDialogOpen
  } = (0, _addressFormContext.useAddressForm)();
  const {
    configForm: {
      onCloseDialog
    }
  } = addressFormProps;
  const contentProps = {
    ...props,
    ...options
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      open: true,
      disableEnforceFocus: isFindPickupPointsOpen,
      header: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h4",
        children: deliveryOptionsTitle
      }),
      maxWidth: "700px",
      onClose: toggleDeliveryOptionsDialog,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryOptionsDialogContent.DeliveryOptionsDialogContent, {
        ...contentProps
      })
    }), isDeliveryOptionsLoaded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
        id: _models.TestId.DialogLoadingOverlayFindPickupPoints
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchConfigurationProvider.SearchConfigurationProvider, {
        children: isMapListMergeEnabled || isFlatSelection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.MapProvider, {
          isMapEnabled: isMapEnabled,
          selectedDeliveryChannel: selectedItem ?? undefined,
          togglePickupPointsDialog: togglePickupPointsDialog,
          onDeliveryItemActivation: onDeliveryItemActivation,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.PickupPointsProvider, {
            enabled: isFindPickupPointsOpen,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectPickupPointDialog, {
              open: isFindPickupPointsOpen
            })
          })
        }) : isFindPickupPointsOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(FindPickupPoints, {
          ...findPickupPointsProps
        }) : null
      })
    }) : null, isAddressFormOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressFormWrapper, {
      open: true,
      header: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressFormTitle, {
        variant: "h4",
        children: addressFormTitle
      }),
      maxWidth: "700px",
      onClose: onCloseDialog,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
          id: _models.TestId.DialogLoadingOverlayAddressForm
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AddressForm, {
          ...addressFormProps
        })
      })
    }) : null, isConfirmDeleteAddressDialogOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
        id: _models.TestId.DialogLoadingOverlayConfirmDeleteAddress
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ConfirmDeleteAddressDialog, {
        ...confirmDeleteAddressDialogProps
      })
    }) : null]
  });
};
exports.DeliveryOptionsDialog = DeliveryOptionsDialog;
var _default = exports.default = DeliveryOptionsDialog;